// extracted by mini-css-extract-plugin
export default {"smallBreakpoint":"600px","mediumBreakpoint":"960px","largeBreakpoint":"1280px"};